export class ErrorClass {
    json() {
        return { success: false, crash: true }
    }
}
